@if (isVisible) {
  <div class="ag-filter" style="width: 100% !important">
    <div>
      <div style="padding: 5px">
        <input #input pInputText [formControl]="inputControl" (keyup)="setSearchResultVisibility()" (click)="unFocusGrid()" (keydown.tab)="focusGrid()" placeholder="Search for an item" [style.width]="'100%'" autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="true" spellcheck="false" type="text"/>
      </div>
      @if (showSearchResults && !isUiTest) {
        <div>
            <div [style]="{'display': (noOptionsTemplate && !searchString && data?.length == 0) ? 'block' : 'none'}" style="padding: 50px 0px; text-align: center; height: 181px; border-top: 1px solid #CCC;
    border-bottom: 1px solid #CCC;"><ng-container *ngTemplateOutlet="noOptionsTemplate"></ng-container></div>
            <div [style]="{'display': (!noOptionsTemplate || (noOptionsTemplate && (searchString || data?.length > 0))) ? 'block' : 'none'}">
              <ag-grid-angular
                style="width: 100%; height: 181px;"
                #agGrid
                class="irb-search-multiple-filter custom-dropdown-class"
                [suppressMovableColumns]="gridOptions.suppressMovableColumns"
                [suppressHorizontalScroll]="true"
                [suppressContextMenu]="true"
                [columnDefs]="gridOptions.columnDefs"
                [components]="frameworkComponents"
                (gridReady)="onGridReady($event)"
                [rowHeight]=30
                [headerHeight]="0"
                [overlayLoadingTemplate]="gridOptions.overlayLoadingTemplate"
                [overlayNoRowsTemplate]="gridOptions.overlayNoRowsTemplate"
                [rowSelection]="gridOptions.rowSelection"
                [rowClassRules]="gridOptions.rowClassRules"
                [suppressRowClickSelection]="true"
                (rowClicked)="onRowClicked($event)"
                >
              </ag-grid-angular>
            </div>
          </div>
        }
      </div>
      <div class="ag-filter-apply-panel" style="justify-content: right !important;">
        @if (params.search) {
          <button type="button" class="ag-standard-button ag-filter-apply-panel-button" ref="resetFilterButton" (click)="onClearAction()">Clear</button>
        }
        @if (!params.search) {
          <button type="button" class="ag-standard-button ag-filter-apply-panel-button" ref="resetFilterButton" (click)="onClearAction()">Cancel</button>
        }
        <button type="button" class="ag-standard-button ag-filter-apply-panel-button" ref="applyFilterButton" [disabled]="!hasChange()" (click)="onApplyAction();">Apply</button>
      </div>
    </div>
  }
